<template>
  <div class="custom-drop-down">
    <div
      @click="isOpen = false"
      v-if="isOpen"
      class="fixed h-full w-full z-40 inset-0"
    ></div>

    <div class="relative">
      <div class="flex items-center cursor-pointer" @click="isOpen = !isOpen">
        <span :class="getLabelClass">{{ label }}</span>

        <svg
          class="ml-1"
          :width="getArrowWidth"
          :height="getArrowHeight"
          viewBox="0 0 11 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.70765 5.12204L9.82969 1L10.4163 1.58467L5.99904 6H5.41437L0.999987 1.58467L1.58561 1L5.70765 5.12204Z"
            fill="#6B6B74"
            stroke="#6B6B74"
            stroke-width="0.5"
          />
        </svg>
      </div>

      <ul v-if="isOpen" class="absolute  p-2 bg-white z-50 shadow-md rounded-md">
        <template v-if="displayKey">
          <li
            :class="getOptionsClass"
            @click="selectItem(item)"
            v-bind:key="index"
            v-for="(item, index) in dataset"
          >
            {{ item[displayKey] }}
          </li>
        </template>
        <template v-else>
          <li
            class="p-1 cursor-pointer hover:bg-gray-200 rounded-sm"
            @click="selectItem(item)"
            v-bind:key="index"
            v-for="(item, index) in dataset"
          >
            {{ item }}
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomDropDown",
  props: {
    label: {
      required: true
    },
    disabled: {
      type: Boolean
    },
    dataset: {
      type: Array,
      required: true
    },
    size: {
      type: String,
      default: "sm"
    },
    displayKey: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    selectItem(value) {
      this.isOpen = false;
      this.$emit("onChanged", value);
    }
  },
  computed: {
    getArrowWidth() {
      switch (this.size) {
        case "2xl":
          return 18;
          break;
        case "md":
          return 14;
          break;
        case "sm":
          return 10;
          break;
      }
    },
    getArrowHeight() {
      switch (this.size) {
        case "2xl":
          return 10;
          break;
        case "md":
          return 9;
          break;
        case "sm":
          return 7;
          break;
      }
    },
    getLabelClass() {
      switch (this.size) {
        case "2xl":
          return "text-2xl font-semibold";
          break;
        
        case "md":
          return "text-md";
          break;

        case "sm":
          return "text-sm";
          break;
      }
    },
    getOptionsClass() {
      switch (this.size) {
        case "2xl":
          return "px-1 py-2 cursor-pointer hover:bg-gray-200 rounded-sm";
        break;
        case "md":
          return "p-1 cursor-pointer hover:bg-gray-200 rounded-sm";
        break;
        case "sm":
          return "p-1 cursor-pointer hover:bg-gray-200 rounded-sm";
        break;
      }
    }
  }
};
</script>
